import React from 'react';
import * as ST from './styled';

const CallsComponent = (props) => {
  return (
    <>
      <ST.CallsBlock>
        <ST.TelephoneContainer>
          <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M8.62601 8.99333C8.90198 8.75699 9.18687 8.62435 9.6072 8.53769C10.5045 8.35269 12.8232 9.43445 13.3167 10.1092C13.8424 10.8278 13.9392 11.7074 13.3386 12.4504C12.7315 13.2002 12.09 13.7688 11.3186 13.9434C9.5134 14.3519 6.10656 13.2073 3.64344 10.4278C1.09934 7.55875 0.154174 3.53954 0.923231 2.01041C1.29451 1.27218 2.09291 0.535217 2.67809 0.275878C3.71786 -0.184919 4.58587 0.0987474 5.11915 0.790727C5.42014 1.18128 6.09366 3.68651 6.09366 4.11859C6.09366 4.62604 5.9406 4.99114 5.60168 5.31044C5.53342 5.37475 5.24995 5.59271 4.99224 5.79627C5.28391 6.42688 5.79432 7.20107 6.27707 7.74499C6.78036 8.31287 7.57654 9.00502 8.2022 9.40482C8.38909 9.22205 8.57373 9.03811 8.62601 8.99333ZM9.88991 9.90885C9.69291 9.94946 9.62487 9.98114 9.53668 10.0567C9.50448 10.0842 9.03878 10.5569 8.77549 10.7902C8.5673 10.9747 8.26962 11.0184 8.01717 10.9016C7.1703 10.5096 5.96648 9.5053 5.22967 8.67394C4.50917 7.86216 3.76505 6.66745 3.48691 5.78908C3.40342 5.52541 3.48301 5.2373 3.69 5.05387C3.98575 4.79179 4.60489 4.32608 4.64166 4.29144C4.69578 4.24045 4.69366 4.24551 4.69366 4.11859C4.69366 3.97108 4.09953 1.76118 4.01025 1.64532C3.84942 1.43663 3.65651 1.37359 3.24533 1.55582C2.94972 1.68682 2.39601 2.19793 2.17396 2.63944C2.05216 2.88162 2.05313 3.90529 2.31131 5.00314C2.67475 6.54865 3.45563 8.10586 4.69108 9.4991C5.90041 10.8638 7.28048 11.7539 8.70691 12.2331C9.6914 12.5639 10.6474 12.6599 11.0096 12.5779C11.3656 12.4973 11.8391 12.0776 12.2502 11.5699C12.3952 11.3905 12.3732 11.1906 12.1867 10.9357C11.9974 10.6768 10.2098 9.84289 9.88991 9.90885Z'
              fill='#F62660'
            />
          </svg>
        </ST.TelephoneContainer>
        <ST.TelephoneInfo>{props.number}</ST.TelephoneInfo>
      </ST.CallsBlock>
      <ST.CallsLink onClick={props.handleClose}>Перезвоните мне</ST.CallsLink>
    </>
  );
};

export default CallsComponent;
